import { CustomDataFieldType } from 'models/CustomDataField';
import * as Yup from 'yup';
import { OptionalObjectSchema } from 'yup/lib/object';

export const addCustomFieldSchema = () => ({
  name: Yup.string().trim().min(1).required(),
  type: Yup.mixed<CustomDataFieldType>()
    .oneOf(Object.values(CustomDataFieldType))
    .required(),
});

export type AddCustomFieldFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof addCustomFieldSchema>>
>;
